// extracted by mini-css-extract-plugin
export default {"root":"SearchModuleRooms_root__PaHP5"};